import React from "react";
import { ProducerBalanceInfoLoaderTemplate } from "themes/administration/producer/components";

function ProducerBalanceInfoLoader(props) {
    return <ProducerBalanceInfoLoaderTemplate {...props} />;
}

export default ProducerBalanceInfoLoader;
